import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import BaseAppService from '../../../../application/platform/scp/base/base-app-service';
import { ACTION_TYPES, usePurchaseSearchDispatch, usePurchaseSearchState } from './purchase-search-context';
import { useBaseLayout } from '../../../../components/context/use-base-layout';

export const usePurchaseSearchController = () => {
    const navigate = useNavigate();
    const { showLoading, showMessage } = useBaseLayout();
    const dispatch = usePurchaseSearchDispatch();
    const state = usePurchaseSearchState();

    useEffect(() => {
        loadInitialData();
    }, []);

    async function loadInitialData() {
        try {
            showLoading({ open: true });

            const disputeMode = await BaseAppService.listDisputeMode();
            const situation = await BaseAppService.listSituationPurchase();
            const modality = await BaseAppService.listModality();

            dispatch({ type: ACTION_TYPES.setDisputeMode, payload: disputeMode });
            dispatch({ type: ACTION_TYPES.setSituation, payload: situation });
            dispatch({ type: ACTION_TYPES.setModality, payload: modality });

            showLoading({ open: false });
        } catch (error) {
            showMessage({
                open: true,
                message: 'Não foi possível carregar os filtros de pesquisa',
                detail: (error as any).details || (error as Error).message,
                type: 'error'
            });
            showLoading({ open: false });
        }
    }

    function handleOnChange(e: any) {
        let term = state.parameters.term;
        let modalityId = state.parameters.modalityId;
        let situationId = state.parameters.situationId;
        let disputeModeId = state.parameters.dispupteModeId;
        let clientId = state.parameters.clientId;
        let year = state.parameters.year;

        if (e.target.name === "input-term") {
            term = e.target.value;
        }
        if (e.target.name === "select-situation") {
            situationId = e.target.value;
        }
        if (e.target.name === "select-dispute-mode") {
            disputeModeId = e.target.value;
        }
        if (e.target.name === "select-modality") {
            modalityId = e.target.value;
        }
        if (e.target.name === "select-client") {
            clientId = e.target.value;
        }
        if (e.target.name === "input-year") {
            const parsed = parseInt(e.target.value, 10);
            year = isNaN(parsed) ? undefined : parsed;
        }

        dispatch({
            type: ACTION_TYPES.updateParameter,
            payload: {
                ...state.parameters,
                term,
                clientId,
                modalityId,
                situationId,
                disputeModeId,
                year
            }
        });
    }

    function handleSearch() {
        dispatch({
            type: ACTION_TYPES.updateParameter,
            payload: {
                ...state.parameters,
                page: 0
            }
        });
        dispatch({ type: ACTION_TYPES.triggerSearch });
    }

    function handleClearFilters() {
        dispatch({
            type: ACTION_TYPES.updateParameter,
            payload: {
                page: 0,
                pageSize: 100,
                term: undefined,
                clientId: undefined,
                modalityId: undefined,
                situationId: undefined,
                dispupteModeId: undefined,
                year: undefined
            }
        });
        dispatch({ type: ACTION_TYPES.triggerSearch });
    }

    function navigateToCreate() {
        navigate('/compras-licitacoes/publicar');
    }

    return {
        handleOnChange,
        handleSearch,
        handleClearFilters,
        navigateToCreate
    };
}
